export const api = {
    accessAuthorizations: (roomId: string): string =>
        `/api/support/access_authorizations/?room_id=${roomId}&filter_active=true`,
    csms: (): string => '/accounts/users/csm/',
    accessAuthorizationUpdate: (authorizationId: string, roomId: string): string =>
        `/api/support/access_authorizations/${authorizationId}/?room_id=${roomId}`,
    supportAccessGrantees: () => '/accounts/users/support_access_grantees/'
};
